import React, { useState, useEffect } from "react";
import '../index.css';
import './PlayerCard.css';
import axios from 'axios';
import Button from '@mui/material/Button';
import '../GearTracker.css'
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import UndoIcon from '@mui/icons-material/Undo';
import JobSelection from "./JobSelection";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Icon from '@mui/material/Icon';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import MissingPieces from "./MissingPieces";
import SetSelection from "./SetSelection";
import Grow from '@mui/material/Grow';
import Snackbar from '@mui/material/Snackbar';
import WarningIcon from '@mui/icons-material/Warning';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

function PlayerCard(props) {

    const [data, setData] = useState({
        fetchingGearset: false,
        selectSet: false,
        sets: {},
        requestReturnedFalse: false,
        vertical: 'bottom',
        horizontal: 'center',
        copied: false,
        pasted: false,
        reset: false,
        invalidJSON: false,
        selected: -1
    })
    const player = props.player;
    if (!player.alts)
        player.alts = [];
    const sides = [['weapon', 'head', 'body', 'hands', 'legs', 'feet'], [null, 'ears', 'neck', 'wrists', 'fingerL', 'fingerR']]

    const { vertical, horizontal, requestReturnedFalse, copied, pasted, reset, invalidJSON } = data;

    function handleChange(e, gearPiece, selectedPlayer) {
        selectedPlayer.neededGear[gearPiece] = e.target.value;
        props.modifyPlayer(player);
    }

    function handleCheckedGear(e, gearPiece, selectedPlayer) {
        selectedPlayer.acquiredGear[gearPiece] = e.target.checked;
        props.modifyPlayer(player);
    }

    function handleCheckedAugment(e, gearPiece, selectedPlayer) {
        selectedPlayer.augmented[gearPiece] = e.target.checked;
        props.modifyPlayer(player);
    }

    function handleNameChange(e, selectedPlayer) {
        if (e.target.value === selectedPlayer.name)
            return;
        selectedPlayer.name = e.target.value;
        props.modifyPlayer(player);
    }

    function keyPress(e, player) {
        if (e.key == 'Enter') {
            handleNameChange(e, player);
            e.target.blur();
        }
    }

    function keyPressEtro(e, player) {
        if (e.key == 'Enter')
            getEtro(player);
    }

    async function processxivgearSets(sets) {
        setData({ ...data, sets: sets, selectSet: true })
    }

    function selectedSet(set, selectedPlayer) {
        var link = document.getElementById(`etroLink${player.playerID}`).value;
        retrievexivgearInfo(set, selectedPlayer, link)
    }

    async function retrievexivgearInfo(set, selectedPlayer, link) {
        selectedPlayer['etroLink'] = link;
        const pieces = {}
        if (Object.keys(set.items).length === 0) {
            setData({ ...data, requestReturnedFalse: true, selectSet: false })
            return;
        }
        pieces[set.items.Weapon.id] = 'weapon';
        pieces[set.items.Head.id] = 'head';
        pieces[set.items.Body.id] = 'body';
        pieces[set.items.Hand.id] = 'hands';
        pieces[set.items.Legs.id] = 'legs';
        pieces[set.items.Feet.id] = 'feet';
        pieces[set.items.Ears.id] = 'ears';
        pieces[set.items.Neck.id] = 'neck';
        pieces[set.items.Wrist.id] = 'wrists';
        pieces[set.items.RingLeft.id] = 'fingerL';
        pieces[set.items.RingRight.id] = 'fingerR';

        var ids = []
        var params = ""
        for (const [key, value] of Object.entries(pieces)) {
            ids.push(value)
            params += `${key},`
        }
        params = params.substring(0, params.length - 1)
        try {
            await axios.get("https://v2.xivapi.com/api/sheet/Item", {
                params: {
                    rows: params
                }
            }).then(res => {
                var gear = res.data.rows;
                const gearID = [];
                gear.forEach((gearPiece) => {
                    let type = "raid";

                    if (!gearPiece) {
                        setData({ ...data, requestReturnedFalse: true, selectSet: false })
                        return;
                    }
                    else if (gearPiece.fields.Name.includes('Augmented'))
                        type = 'tome';
                    gearID[pieces[gearPiece.row_id]] = { 'type': type, id: gearPiece.row_id, name: gearPiece.fields.Name }

                })
                callBack(gearID, selectedPlayer)
            })
        }
        catch (e) {
            console.log(e)
            setData({ ...data, fetchingGearset: false, selectSet: false });
            document.getElementById(`etroLink${player.playerID}`).value = '';
            selectedPlayer['etroLink'] = '';
            props.etroFailed();
        }
    }

    async function getxivgear(xivgearLink, player) {
        var id = xivgearLink.split('%7C')[1];
        if (!id)
            id = xivgearLink.split('|')[1];
        id = id.split('&')[0]
        var url = `https://api.xivgear.app/shortlink/${id}`

        try {
            await axios.get(url).then((res) => {

                if (res.data.sets) {
                    processxivgearSets(res.data.sets, player)
                }
                else {
                    retrievexivgearInfo(res.data, player, xivgearLink)
                }
            })
        }
        catch (e) {
            console.log(e)
            setData({ ...data, fetchingGearset: false });
            document.getElementById(`etroLink${player.playerID}`).value = '';
            props.player['etroLink'] = '';
            props.etroFailed();
        }
    }

    async function getEtro(selectedPlayer) {

        var etroLink = document.getElementById(`etroLink${player.playerID}`).value;
        if (etroLink == "")
            return;
        setData({ ...data, fetchingGearset: true });
        if (etroLink.split('/')[2] == 'xivgear.app') {
            getxivgear(etroLink, selectedPlayer)
            return;
        }
        let url = `https://etro.gg/api/gearsets/${etroLink.split('/').slice(-1)[0]}`
        try {
            await axios.get(url).then(async (res) => {
                const data2 = res.data;
                const neededGear = {};
                var params = "";
                Object.keys(selectedPlayer.neededGear).forEach((gearPiece) => {
                    neededGear[data2[gearPiece]] = gearPiece;
                    params += `${data2[gearPiece]},`;
                });
                params = params.substring(0, params.length - 1)
                console.log(params)
                params = params.substring(0, params.length - 1)
                try {
                    await axios.get("https://v2.xivapi.com/api/sheet/Item", {
                        params: {
                            rows: params
                        }
                    }).then(res => {
                        var gear = res.data.rows;
                        const gearID = [];
                        gear.forEach((gearPiece) => {
                            let type = "raid";

                            if (!gearPiece) {
                                setData({ ...data, requestReturnedFalse: true, selectSet: false })
                                return;
                            }
                            else if (gearPiece.fields.Name.includes('Augmented'))
                                type = 'tome';
                            gearID[neededGear[gearPiece.row_id]] = { 'type': type, id: gearPiece.row_id, name: gearPiece.fields.Name }

                        })
                        callBack(gearID, selectedPlayer)
                    })
                }
                catch (e) {
                    console.log(e)
                    setData({ ...data, fetchingGearset: false, selectSet: false });
                    document.getElementById(`etroLink${player.playerID}`).value = '';
                    props.player['etroLink'] = '';
                    props.etroFailed();
                }
                selectedPlayer.etroLink = etroLink;
                document.getElementById(`etroLink${player.playerID}`).blur();
            })
        }
        catch (e) {
            setData({ ...data, fetchingGearset: false, selectSet: false });
            document.getElementById(`etroLink${player.playerID}`).value = '';
            selectedPlayer['etroLink'] = '';
            props.etroFailed();
            console.log(e);
        }
    }

    function callBack(gearID, selectedPlayer) {
        const neededGear = Object.keys(gearID)
        neededGear.forEach((gearPiece) => {
            selectedPlayer.neededGear[gearPiece] = gearID[gearPiece].type;
        })
        props.modifyPlayer(player)
        setData({ ...data, fetchingGearset: false, selectSet: false });
    }

    function jobSelector(job, role, selectedPlayer) {
        selectedPlayer['role'] = role;
        selectedPlayer['job'] = job;
        if (selectedPlayer.role === 'tank')
            selectedPlayer['color'] = '#4557a6'
        else if (selectedPlayer.role === 'healer')
            selectedPlayer['color'] = '#45773b'
        else if (selectedPlayer.role === 'dps')
            selectedPlayer['color'] = '#813b3c'
        else {
            selectedPlayer['color'] = '#5f5f5f'
        }
        props.modifyPlayer(player)
    }

    function normalizeGear(gearPiece) {
        var normalizedGear = gearPiece;
        if (gearPiece == 'fingerL' || gearPiece == "fingerR")
            normalizedGear = 'ring'
        return normalizedGear.toUpperCase();
    }

    function twineOrShine(gearPiece) {
        if (gearPiece === 'weapon') {
            return 'augment'
        }
        if (sides[0].includes(gearPiece)) {
            return 'twine'
        }
        else {
            return 'shine'
        }
    }

    function saveMissing(player) {
        props.saveMissing(player)
    }

    function closeSetSelection() {
        setData({ ...data, sets: {}, selectSet: false })
    }

    function handleClose() {
        setData({ ...data, requestReturnedFalse: false, copied: false, invalidJSON: false, reset: false, pasted: false })
    }

    function copyToClipboard(selectedPlayer) {
        var gearset = JSON.stringify({ neededGear: selectedPlayer.neededGear })
        navigator.clipboard.writeText(gearset)
        setData({ ...data, copied: true })
    }
    function pasteFromClipboard(selectedPlayer) {
        navigator.clipboard.readText().then((val) => {
            try {
                var gearset = JSON.parse(val);
                if (!gearset.neededGear) {
                    setData({ ...data, invalidJSON: true })
                    return;
                }
                selectedPlayer['neededGear'] = gearset.neededGear;
                props.modifyPlayer(player)
                setData({ ...data, pasted: true })
            }
            catch (e) {
                console.log(e)
                setData({ ...data, invalidJSON: true })
            }
        })

    }
    function resetGearset(selectedPlayer) {
        selectedPlayer['acquiredGear'] = {
            weapon: false,
            head: false,
            body: false,
            hands: false,
            legs: false,
            feet: false,
            ears: false,
            neck: false,
            wrists: false,
            fingerL: false,
            fingerR: false
        };
        selectedPlayer['neededGear'] = {
            weapon: "raid",
            head: "raid",
            body: "raid",
            hands: "raid",
            legs: "raid",
            feet: "raid",
            ears: "raid",
            neck: "raid",
            wrists: "raid",
            fingerL: "raid",
            fingerR: "tome"
        };
        selectedPlayer['augmented'] = {
            weapon: false,
            head: false,
            body: false,
            hands: false,
            legs: false,
            feet: false,
            ears: false,
            neck: false,
            wrists: false,
            fingerL: false,
            fingerR: false
        };
        props.modifyPlayer(player);
        setData({ ...data, reset: true })
    }

    function switchTo(mode) {
        setData({ ...data, selected: mode })
        if (mode != -1) {
            document.getElementById(`etroLink${player.playerID}`).value = player.alts[mode].etroLink;
        }
        else {
            document.getElementById(`etroLink${player.playerID}`).value = player.etroLink;
        }

    }

    function createAlt() {
        var alt = {
            acquiredGear: {
                weapon: false,
                head: false,
                body: false,
                hands: false,
                legs: false,
                feet: false,
                ears: false,
                neck: false,
                wrists: false,
                fingerL: false,
                fingerR: false
            },
            neededGear: {
                weapon: "raid",
                head: "raid",
                body: "raid",
                hands: "raid",
                legs: "raid",
                feet: "raid",
                ears: "raid",
                neck: "raid",
                wrists: "raid",
                fingerL: "raid",
                fingerR: "tome"
            },
            augmented: {
                weapon: false,
                head: false,
                body: false,
                hands: false,
                legs: false,
                feet: false,
                ears: false,
                neck: false,
                wrists: false,
                fingerL: false,
                fingerR: false
            },
            role: player.role,
            job: player.job,
            etroLink: "",
            color: player.color
        }
        player.alts.push(alt)
        props.modifyPlayer(player)
        switchTo(player.alts.length - 1);
    }

    function deleteAlt() {
        player.alts.splice(data.selected, 1);
        props.modifyPlayer(player);
    }

    function generatePlayer() {

        var selectedPlayer = player;
        if (data.selected != -1 && player.alts[data.selected]) {
            selectedPlayer = player.alts[data.selected];
        }
        else if (data.selected != -1 && !player.alts[data.selected]) {
            setData({ ...data, selected: -1 })
        }

        return (
            <div>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2} id={`playerTable${player.playerID}`} style={{ background: selectedPlayer.color, color: 'aliceblue', borderTopRightRadius: '20px', borderBottom: '2px solid #9f7c1f' }}>
                        <JobSelection job={selectedPlayer.job} selectedJob={(selectedJob, role) => jobSelector(selectedJob, role, selectedPlayer)} />
                        <Grid size={8} style={{ marginTop: '5px' }}>
                            <TextField
                                id={`playerName${player.playerID}`} variant="standard" type="text" name="playerName" defaultValue={player.name}
                                sx={{ input: { textAlign: 'center', color: 'aliceblue', borderBottom: "2px solid #ffffff" }, label: { color: 'aliceblue' }, width: '100%' }}
                                onBlur={(e) => handleNameChange(e, player)} onKeyDown={(e) => keyPress(e, player)} slotProps={{ htmlInput: { maxLength: 21 } }}
                            />
                        </Grid>
                        <div className='buffer'></div>
                        {data.selected > -1 ? <Grid size={1}>
                            <div className='delete-btn-wrapper'>
                                <Tooltip title="Delete" placement="top" slotProps={{ tooltip: { sx: { fontSize: '16px', fontFamily: 'Noto Sans', }, }, popper: { modifiers: [{ name: "offset", options: { offset: [0, -10], }, },], } }}>
                                    <IconButton className='delete-alt-btn' disableElevation={true} size="small" onClick={deleteAlt}><DeleteTwoToneIcon style={{ color: 'ffffff', width: '30px', height: '30px' }} /></IconButton> </Tooltip></div>
                        </Grid> : null}

                    </Grid>
                    <MissingPieces player={selectedPlayer} saveMissing={saveMissing} />
                    <Grid container spacing={0} style={{ backgroundColor: '#37373a', paddingBottom: '5px' }}>
                        {sides.map((side) =>
                            <Grid key={`${player.playerID}-${side}`} size={6}>
                                {side.map((gearPiece) =>
                                    <div key={`${player.playerID}-${gearPiece}`} className='piece'>
                                        {gearPiece ? (
                                            <Grid container spacing={0} style={{ backgroundColor: '#555555', border: "1px solid black", borderTopRightRadius: '10px', height: '55px' }} className={gearPiece}>
                                                <Grid size={6} style={{ marginBottom: '-3px', marginTop: '2px', marginLeft: '5px', fontSize: '12px' }}>
                                                    <img src={require(`../FFXIVIcons/General/${selectedPlayer.neededGear[gearPiece]}.png`)} style={{ width: '15px', marginRight: '5px', marginBottom: '-3px' }} />{`${normalizeGear(gearPiece)}`}
                                                </Grid>
                                                <Grid size={2} style={{ marginBottom: '-10px', textAlign: "center", marginLeft: '12px' }}>
                                                    <img src={require(`../FFXIVIcons/General/acquired.png`)} style={{ width: '25px', marginTop: '0px', marginBottom: '-5px' }} />
                                                </Grid>
                                                <Grid size={2} style={{ marginBottom: '-10px', textAlign: "center" }}>
                                                    {selectedPlayer.neededGear[gearPiece] === 'tome' ? <img src={require(`../FFXIVIcons/General/${twineOrShine(gearPiece)}.png`)} style={{ width: '18px', marginTop: '2px', marginBottom: '-5px' }} /> :
                                                        <Icon style={{ width: '20px', marginTop: '2px', marginBottom: '-5px' }} />}
                                                </Grid>
                                                <Grid size={6} className="gearType" style={{ margin: '5px' }}>
                                                    <Select
                                                        displayEmpty
                                                        id={`${gearPiece}-${player.playerID}`}
                                                        value={selectedPlayer.neededGear[gearPiece]}
                                                        IconComponent={(_props) => {
                                                            return (
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        cursor: "pointer",
                                                                        pointerEvents: "none",
                                                                        right: 6,
                                                                        bottom: 9,
                                                                        height: "10px",
                                                                        width: "10px",
                                                                    }}
                                                                >
                                                                    <KeyboardArrowDownIcon style={{ height: '15px', width: '15px' }} />
                                                                </div>
                                                            );
                                                        }}
                                                        sx={{ color: 'black', width: '100%', fontSize: '12px', height: '25px', borderRadius: '0px', backgroundColor: '#7d7d7d', border: '1px solid black', fontFamily: 'Noto Sans' }}
                                                        onChange={(e) => handleChange(e, gearPiece, selectedPlayer)}
                                                    >
                                                        <MenuItem value={"raid"}>RAID</MenuItem>
                                                        <MenuItem value={"tome"}>TOME</MenuItem>
                                                        <MenuItem value={"other"}>OTHER</MenuItem>
                                                    </Select>
                                                </Grid>
                                                <Grid size={2} className='checkBox'>
                                                    <Checkbox
                                                        checked={selectedPlayer.acquiredGear[gearPiece]}
                                                        onChange={(e) => handleCheckedGear(e, gearPiece, selectedPlayer)}
                                                        sx={{
                                                            color: '#b7b7b7',
                                                            '&.Mui-checked': {
                                                                color: 'aliceblue',
                                                            },
                                                            borderRadius: '0px'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={2} className='checkBox'>
                                                    {selectedPlayer.neededGear[gearPiece] === 'tome' ?
                                                        (<Checkbox
                                                            checked={selectedPlayer.augmented[gearPiece]}
                                                            onChange={(e) => handleCheckedAugment(e, gearPiece, selectedPlayer)}
                                                            sx={{
                                                                color: '#b7b7b7',
                                                                '&.Mui-checked': {
                                                                    color: 'aliceblue',
                                                                },
                                                                '&.Mui-disabled': {
                                                                    color: '#777777'
                                                                },
                                                                borderRadius: '0px'
                                                            }}

                                                        //disabled={!player.acquiredGear[gearPiece]}
                                                        />) : <Icon />}
                                                </Grid>
                                            </Grid>) : (
                                            <Grid container spacing={1} className='null' style={{ height: '55px' }}>
                                                <Tooltip title="Copy" placement="top" slotProps={{ tooltip: { sx: { fontSize: '16px', fontFamily: 'Noto Sans', }, }, popper: { modifiers: [{ name: "offset", options: { offset: [0, -10], }, },], } }}>
                                                    <Button className='action-btn' variant="contained" disableElevation={true} onClick={() => copyToClipboard(selectedPlayer)}><ContentCopyIcon style={{ color: '#fad99a' }} /></Button>
                                                </Tooltip>
                                                <Tooltip title="Paste" placement="top" slotProps={{ tooltip: { sx: { fontSize: '16px', fontFamily: 'Noto Sans', }, }, popper: { modifiers: [{ name: "offset", options: { offset: [0, -10], }, },], } }}>
                                                    <Button className='action-btn' variant="contained" disableElevation={true} onClick={() => pasteFromClipboard(selectedPlayer)}><ContentPasteIcon style={{ color: '#fad99a' }} /></Button>
                                                </Tooltip>
                                                <Tooltip title="Reset" placement="top" slotProps={{ tooltip: { sx: { fontSize: '16px', fontFamily: 'Noto Sans', }, }, popper: { modifiers: [{ name: "offset", options: { offset: [0, -10], }, },], } }}>
                                                    <Button className='action-btn' variant="contained" disableElevation={true} onClick={() => resetGearset(selectedPlayer)}><RestartAltIcon style={{ color: '#fad99a' }} /></Button>
                                                </Tooltip>
                                            </Grid>
                                        )}

                                    </div>
                                )}
                            </Grid>)}

                    </Grid>
                    <div style={{ backgroundColor: '#686a6b', margin: '5px', marginTop: '0px', marginLeft: '4px' }}>
                        <TextField
                            id={`etroLink${player.playerID}`} variant="outlined" type="text" name="etroLink" defaultValue={selectedPlayer.etroLink} label='ETRO/XIVGEAR LINK'
                            sx={{
                                input: { color: '#4fecff', borderBottom: "none", height: '10px', fontSize: '14px', border: 'none', borderRadius: '0px', fontFamily: 'Noto Sans' },
                                label: { color: 'black', "&.Mui-focused": { color: "black" }, fontSize: '14px', marginTop: '2px', fontFamily: 'Noto Sans', border: 'none' },
                                ".MuiOutlinedInput-root": {
                                    fieldset: { border: "1px solid black", borderRadius: '0px' },
                                    "&.Mui-focused fieldset": {
                                        border: "1px solid #c2ab6d",
                                        color: 'black'
                                    },
                                },

                                width: '100%', minHeight: '10px', border: '1px solid #c2ab6d'
                            }}
                            onKeyDown={(e) => keyPressEtro(e, selectedPlayer)}
                            slotProps={{
                                input: {
                                    endAdornment:
                                        <InputAdornment position="end">
                                            <Button variant="outlined"
                                                aria-label="description for action"
                                                loading={data.fetchingGearset} disabled={data.fetchingGearset}
                                                onClick={() => getEtro(selectedPlayer)}
                                                style={{ borderRadius: '0px', backgroundColor: '#fad99a', border: '1px solid black', color: 'black', height: '27px', minWidth: '20px', width: '60px', marginRight: '-5px' }}
                                            >
                                                {!data.fetchingGearset ? <SearchIcon style={{ height: '20px', marginTop: '2px' }} /> : null}
                                            </Button>
                                        </InputAdornment>
                                },
                                inputLabel: {
                                    size: "small",
                                }
                            }}
                        />
                    </div>
                </Box>
                {data.selectSet ? <SetSelection closeSetSelection={closeSetSelection} sets={data.sets} player={selectedPlayer} selectedSet={selectedSet} /> : null}
            </div>

        )
    }

    function undo() {
        setData({ ...data, mode: -1 })
        props.undoChanges(player)

    }

    return (
        <div style={{ margin: '15px' }} className='player-wrapper'>
            <div className='alts-wrapper'>
                <div className={data.selected == -1 ? 'alts-btn-outer-main' : 'alts-btn-outer-main-unselected'} id='main-btn-outer' >
                    <Button id='main-btn' disableElevation={true} className='main-btn' variant="contained" onClick={() => { switchTo(-1) }} style={{ background: `${data.selected == -1 ? player.color : 'rgba(133, 133, 133)'}`, zIndex: `${data.selected == -1 ? 5 : 0}` }}>Main
                    </Button>
                </div>
                {player.alts[0] ?
                    <div className={data.selected == 0 ? 'alts-btn-outer-alt' : 'alts-btn-outer-alt-unselected'} id='alt-btn-outer-1'>
                        <Button id='alt-btn-1' disableElevation={true} className='alts-btn' variant="contained" onClick={() => { switchTo(0) }} style={{ background: `${data.selected == 0 ? player.alts[0].color : 'rgba(133, 133, 133)'}`, zIndex: `${data.selected == 0 ? 5 : 0}` }}>1
                        </Button>
                    </div>
                    : null}
                {player.alts[1] ?
                    <div className={data.selected == 1 ? 'alts-btn-outer-alt' : 'alts-btn-outer-alt-unselected'} id='alt-btn-outer-2'>
                        <Button id='alt-btn-2' disableElevation={true} className='alts-btn' variant="contained" onClick={() => { switchTo(1) }} style={{ background: `${data.selected == 1 ? player.alts[1].color : 'rgba(133, 133, 133)'}`, zIndex: `${data.selected == 1 ? 5 : 0}` }}>2
                        </Button>
                    </div>
                    : null}
                {player.alts[2] ?
                    <div className={data.selected == 2 ? 'alts-btn-outer-alt' : 'alts-btn-outer-alt-unselected'} id='alt-btn-outer-3'>
                        <Button id='alt-btn-3' disableElevation={true} className='alts-btn' variant="contained" onClick={() => { switchTo(2) }} style={{ background: `${data.selected == 2 ? player.alts[2].color : 'rgba(133, 133, 133)'}`, zIndex: `${data.selected == 2 ? 5 : 0}` }}>3
                        </Button>
                    </div>
                    : null}
                {player.alts.length < 3 ?
                    <div className='alts-btn-outer-alt-unselected' id='alt-btn-outer-add'>
                        <Tooltip title="Add Alt" placement="top" slotProps={{ tooltip: { sx: { fontSize: '16px', fontFamily: 'Noto Sans', marginBottom: '-50px' }, }, popper: { modifiers: [{ name: "offset", options: { offset: [0, -3] }, },], } }}>
                            <Button id='alt-btn-add' disableElevation={true} className='alts-btn' variant="contained" onClick={createAlt}>+
                            </Button>
                        </Tooltip>
                    </div>
                    : null}


            </div>
            <div style={{ position: 'relative', maxWidth: '400px', minWidth: '350px', border: '2px solid #c2ab6d', position: "relative", borderTopRightRadius: '23px', backgroundColor: '#37373a' }}>
                <div className={`i${player.playerID}`} style={{ border: '1px solid rgb(0, 0, 0)', borderTopRightRadius: '21px' }}>
                    {generatePlayer()}
                </div>
                <Grow in={player.modified}>
                    <div style={{ borderBottom: '2px solid #c2ab6d', borderRight: '2px solid #c2ab6d', background: '#555555', borderLeft: '2px solid #c2ab6d', position: 'absolute', width: "100%", zIndex: 5, marginTop: '-1px', marginLeft: '-2px' }}>
                        <div style={{
                            borderBottom: '1px solid black', borderRight: '1px solid black', borderLeft: '1px solid black', borderTop: 'none'
                        }}>
                            <Button style={{ width: "80%", borderRadius: '0px', height: '30px', backgroundColor: '#37373a' }}
                                variant="contained" disableElevation={true} id="submit" color="primary" type="submit" onClick={() => props.updatePlayer(player)}>Save</Button>
                            <Button style={{ width: "20.005%", borderRadius: '0px', height: '30px', background: '#e25757' }}
                                variant="contained" disableElevation={true} id="submit" color="primary" type="submit" onClick={undo}><UndoIcon /></Button>
                        </div>
                    </div>
                </Grow>

                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={requestReturnedFalse}
                    autoHideDuration={10000}
                    onClose={handleClose}
                    style={{ minWidth: '1000px' }}
                    message={
                        <div><div style={{ float: "right", margin: '5px' }}><WarningIcon style={{ width: '20px', color: '#ffe23d', marginRight: '5px', marginBottom: '-7px' }} />Request succeeded, but one or more items failed to be retrieved. This may be caused by a xivapi outage or an unknown item id (new item?).</div></div>
                    }
                />
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={invalidJSON}
                    autoHideDuration={2000}
                    onClose={handleClose}
                    style={{ minWidth: '200px' }}
                    message={
                        <div><div style={{ float: "right", margin: '5px' }}><CancelIcon style={{ width: '20px', color: '#d35f56', marginRight: '5px', marginBottom: '-7px' }} />Invalid JSON.</div></div>
                    }
                />
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={copied}
                    autoHideDuration={2000}
                    onClose={handleClose}
                    style={{ minWidth: '200px' }}
                    message={
                        <div><div style={{ float: "right", margin: '5px' }}><CheckCircleIcon style={{ width: '20px', color: '#56d36a', marginRight: '5px', marginBottom: '-7px' }} />Gearset copied.</div></div>
                    }
                />
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={pasted}
                    autoHideDuration={2000}
                    onClose={handleClose}
                    style={{ minWidth: '200px' }}
                    message={
                        <div><div style={{ float: "right", margin: '5px' }}><CheckCircleIcon style={{ width: '20px', color: '#56d36a', marginRight: '5px', marginBottom: '-7px' }} />Gearset pasted.</div></div>
                    }
                />
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={reset}
                    autoHideDuration={2000}
                    onClose={handleClose}
                    style={{ minWidth: '200px' }}
                    message={
                        <div><div style={{ float: "right", margin: '5px' }}><CheckCircleIcon style={{ width: '20px', color: '#56d36a', marginRight: '5px', marginBottom: '-7px' }} />Gearset reset.</div></div>
                    }
                />
            </div>
        </div>
    );
}

export default PlayerCard;